import React from "react";
import { Paper, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import eventsData from "../../../pages/Events/eventsData.json";
import styles from "./EventsPreview.module.scss";
import { EventAvailable } from "@mui/icons-material";

const EventsPreview: React.FC = () => {
    const upcomingEvents = eventsData.events
        .filter((event) => {
            const eventDate = new Date(event.date);
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Compare dates only
            return eventDate >= today;
        })
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        .slice(0, 3);

    return (
        <Paper className={styles.eventsPreview}>
            <Typography variant="h6" className={styles.title}>
                <EventAvailable sx={{ verticalAlign: "middle", marginRight: "8px" }} />
                Upcoming Events
            </Typography>
            {upcomingEvents.map((event) => (
                <div key={event.id} className={styles.eventItem}>
                    <Typography variant="subtitle1" className={styles.eventTitle}>
                        {event.title}
                    </Typography>
                    <Typography variant="body2" className={styles.eventDetails}>
                        {event.date} - {event.location}
                    </Typography>
                </div>
            ))}
            <Link to="/events" className={styles.viewAllLink}>
                View All Events
            </Link>
        </Paper>
    );
};

export default EventsPreview;
